// Makes stray whitespace in a stored email visible: spaces become ␣, tabs \t, and any
// other whitespace or invisible character (e.g. a non-breaking space, which
// JSON.stringify leaves as-is) its \uXXXX code.
const showInvisibleCharacters = (value) => String(value ?? '').replace(/[\s​-‍﻿]/g, (char) => {
  if (char === ' ') return '␣';
  if (char === '\t') return '\\t';
  return `\\u${char.charCodeAt(0).toString(16).toUpperCase().padStart(4, '0')}`;
});

export default showInvisibleCharacters;
